import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import { History } from "history";
import { authorizationReducer, AuthorizationState } from "store/features/authorization/authorization.reducer";
import { emailSchedulerReducers, EmailSchedulerState } from "store/features/emailScheduler/emailScheduler.reducers";
import { generalReducer, GeneralState } from "store/features/general/general.reducer";
import { templatesReducers, TemplatesState } from "store/features/templates/templates.reducers";
import {
    creativeMappingsReducers,
    CreativeMappingsState,
} from "store/features/creativeMappings/creativeMappings.reducers";
import { filtersFieldsReducer, FiltersState } from "store/features/filters";
import { materialSpecsReducers, MaterialSpecsState } from "store/features/materialSpecs/materialSpecs.reducers";
import { briefFormReducer, BriefFormState } from "./features/briefForm/briefForm.reducer";
import { adReducer, AdState } from "./features/materialSpecs/ad/ad.reducers";
import { formsReducer, FormsState } from "store/features/forms/forms.reducer";
import { annotationsReducer, AnnotationsState } from "./features/annotations/annotations.reducers";

export interface AppState {
    authorization: AuthorizationState;
    annotations: AnnotationsState;
    emailScheduler: EmailSchedulerState;
    general: GeneralState;
    templates: TemplatesState;
    creativeMappings: CreativeMappingsState;
    filters: FiltersState;
    materialSpecs: MaterialSpecsState;
    briefForm: BriefFormState; // TODO: move this to sub-reducer
    ad: AdState; // TODO: move this to sub-reducer
    forms: FormsState;
    router: History<History.PoorMansUnknown>;
}

const createRootReducer = (history: History<History.PoorMansUnknown>) =>
    combineReducers<AppState>({
        authorization: authorizationReducer,
        annotations: annotationsReducer,
        emailScheduler: emailSchedulerReducers,
        general: generalReducer,
        templates: templatesReducers,
        creativeMappings: creativeMappingsReducers,
        filters: filtersFieldsReducer,
        materialSpecs: materialSpecsReducers,
        briefForm: briefFormReducer,
        ad: adReducer,
        forms: formsReducer,
        // eslint-disable-next-line
        router: connectRouter(history) as any, // needs different interface?
    });

export default createRootReducer;
